var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex align-items-center" },
    [
      _c(
        _setup.Button,
        {
          staticClass: "me-2 border",
          nativeOn: {
            click: function ($event) {
              return _setup.internalLink.apply(null, arguments)
            },
          },
        },
        [_vm._v("Browse…")]
      ),
      _vm._v(" "),
      _setup.pageId || _setup.contentId
        ? _c(
            "p",
            { staticClass: "well m-0 p-1 text-nowrap" },
            [
              _c(_setup.PagePath, {
                attrs: {
                  "page-id": _setup.pageId,
                  "page-content-id": _setup.contentId,
                },
              }),
              _vm._v(" "),
              !_vm.removeDisabledBtn
                ? _c(
                    _setup.Button,
                    {
                      staticClass: "btn-sm",
                      nativeOn: {
                        click: function ($event) {
                          return _vm.onChange(0)
                        },
                      },
                    },
                    [_c("i", { staticClass: "bi-x-lg" })]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }